import { FileText } from "lucide-react";
import { DOCS } from "./content2";
import { NOTE_DOCS } from "./notesContent";

const ALL_DOCS = [...DOCS, ...NOTE_DOCS];

export const Documents = () => (
  <section id="documents" className="bg-mm-alt text-mm-ink py-24 md:py-32 border-t border-mm-ink/10" data-testid="documents-section">
    <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-[160px_1fr] gap-12">
      <p className="mm-lab text-mm-golddark">Les documents</p>
      <div className="min-w-0">
        <h2 className="disp mm-h2">Lire, vérifier, refaire le calcul</h2>
        <p className="mm-body mt-4 max-w-xl">Les dossiers complets, à télécharger et à faire circuler.</p>
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
          {ALL_DOCS.map((d) => (
            <li key={d.id}>
              <a href={d.url} target="_blank" rel="noopener noreferrer" data-testid={`doc-${d.id}-download`} className="group flex flex-col h-full bg-mm-paper border-2 border-mm-ink p-6 hover:bg-mm-ink hover:text-mm-paper transition-colors">
                <FileText className="w-8 h-8 text-mm-red" />
                <span className="disp text-2xl mt-4 leading-tight">{d.title}</span>
                <span className="mm-lab mt-auto pt-6">PDF · {d.pages} · Télécharger →</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
